import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PlanInterface } from 'src/interfaces/plan'

type State = {
  loading: boolean
  entity: PlanInterface | null
}

const initialState: State = {
  loading: false,
  entity: null,
}

const { actions, reducer } = createSlice({
  // TODO: remember change the name of store
  name: 'SelectedPlan',
  initialState,
  reducers: {
    updateEntity: (state, action: PayloadAction<PlanInterface>) => {
      state.entity = action.payload
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export { reducer }
export default actions
